export const AWS_PROFESSIONAL = {
    weeks: 2,
    modules: [
        [
            {
                title:
                    'Introduction',
                topics: ["Prerequisites", "About the Course & Exam", "About Hands-on Labs"]
            },
            {
                title: 'Networking',
                topics: ["Introduction", "Concepts", "Network to VPC Connectivity", "VPC to VPC Connectivity", "Internet Gateways", "Routing",
                    "Enhanced Networking", "Route 53", "CloudFront", "Elastic Load Balancers",
                    "Lab - Problem 1", "Lab - Problem 2"]
            },
            {
                title: 'Storage & Data Stores',
                topics: ["Introduction & Concepts Overview ", "S3 ", "Glacier", "Elastic Block Storage & Elastic File System", "Storage Gateway", "EC2 Databases ", "RDS - Aurora, DynamoDB", "Redshift", "Neptune", "Elasticache", "Other Datastore Options", "Comparing DB Options", "Lab - Problem 1", "Lab - Problem 2"]
            },
            {
                title: 'Security',
                topics: ["Introduction", "Concepts", "Multi-Account Management", "Network Controls and Security Groups", "AWS Directory Services", "Credentials and Access Management", "Encryption", "Distributed Denial of Service Attacks", "IDS and IPS", "Service Catalog", "Lab - Problem 1", "Lab - Problem 2"],
            },
            {
                title: 'Architecting Applications for Scale',
                topics: ["Introduction", "Concepts", "Auto-Scaling", "Kinesis", "DynamoDB Scaling", "CloudFront Part 2", "SNS", "SQS", "Lambda, Serverless Application Model & EventBridge", "Simple Workflow Service", "Step Functions & Batch", "Elastic MapReduce", "Lab - Problem 1", "Lab - Problem 2"]
            },
            {
                title: 'High-Availability',
                topics: ["Introduction", "AWS Continuum of HA", "Storage HA Options", "Compute HA Options", "Database HA Options", "Network HA Options"],
            },
            {
                title: 'Deployment & Ops Mgmt',
                topics: ["Introduction", "Types of Deployments", "Continuous Integration & Deployment", "Elastic Beanstalk", "CloudFormation", "Elastic Container Service", "API Gateway", "Management Tools", "AWS System Manager", "Enterprise Apps", "Machine Learning Landscape", "Lab - Problem 1", "Lab - Problem 2"]
            },
            {
                title: 'Cost Management',
                topics: ["Introduction", "Cost Optimization Strategies", "Tagging & Resource Groups", "Spot & Reserved Instances", "Cost Management Tools"]
            },
            {
                title: 'Hands-on Practice & Exam Preparation',
                topics: ["Hands on Labs Practice", "Prep for AWS Certified Solutions Architect - Professional Exam"]
            },
        ]
    ]

}


export const AWS_ASSOCIATE = {
    weeks: 2,
    modules: [
        [
            {
                title:
                    'AWS Overview',
                topics: ["History", "How to Register for AWS", "AWS Console, CLI & SDKs"]
            },
            {
                title: 'Identity & Access Management',
                topics: ["IAM - Users, Roles, Groups, Permissions, Service Accounts, etc.", "AWS Directory Service ", "IAM Policies ", "AWS Resource Access Manager (RAM) ", "AWS Single Sign-On ", "Advanced IAM Summary"]
            },
            {
                title: 'Compute',
                topics: ["EC2 Overview ", "EC2 Instance Types", "EC2 Autoscaling, Hibernate, Placement Groups ", "AWS Lambda", "Containers & ECS/EKS"]
            },
            {
                title: 'Networking',
                topics: ["Introduction ", "Concepts ", "Network to VPC Connectivity ", "VPC to VPC Connectivity ", "Internet Gateways ", "Routing ", "Enhanced Networking ", "Route 53 ", "CloudFront ", "Elastic Load Balancers"]
            },
            {
                title: 'Storage & Data Stores',
                topics: ["Introduction & Concepts Overview ", "S3", "Glacier ", "Elastic Block Storage & Elastic File System ", "Storage Gateway", "EC2 Databases", "RDS - Aurora, DynamoDB ", "Redshift", "Neptune ", "Elasticache ", "Other Datastore Options ", "Comparing DB Options"]
            },
            {
                title: 'Application Services',
                topics: ["SQS", "Simple Workflow Service ", "Simple Notification Service", "Elastic Transcoder", "API Gateway ", "Kinesis 101 ", "Web Identity Federation and Cognito ", "Event Processing Patterns"]
            },
            {
                title: 'Security',
                topics: ["Reducing Security Threats", "Key Management Service (KMS)", "CloudHSM", "Secrets Manager ", "AWS Shield ", "Web Application Firewall (WAF)"]
            },
            {
                title: 'Monitoring & Automation',
                topics: ["CloudWatch", "CloudFormation"],
            },
            {
                title: 'Hands-on Practice & Exam Preparation',
                topics: ["Practice Exercise 1", "Practice Exercise 2", "Exam Prep Notes"]
            },
        ]
    ]
}

export const KUBE_DEV = {
    weeks: 2,
    modules: [
        [
            {
                title:
                    'Core Concepts',
                topics: [
                    "Build Your Practice Cluster",
                    "Kubernetes API Primitives",
                    "Creating Pods",
                    "Namespaces",
                    "Basic Container Configuration"
                ]
            },
            {
                title: 'Configuration',
                topics: [
                    "ConfigMaps",
                    "SecurityContexts",
                    "Resource Requirements",
                    "Secrets",
                    "ServiceAccounts",
                    "Multi-Container Pods - Understanding Multi-Container Pods"
                ]
            },
            {
                title: 'Observability',
                topics: [
                    "Liveness & Readiness Probes",
                    "Container Logging",
                    "Installing Metrics Server",
                    "Monitoring Applications",
                    "Debugging"
                ]
            },
            {
                title: 'Pod Design',
                topics: [
                    "Labels, Selectors, & Annotations",
                    "Deployments",
                    "Rolling Updates & Rollbacks",
                    "Jobs & CronJobs"
                ]
            },
            {
                title: 'Services and Networking',
                topics: ['Services', 'Network Policies']
            },
            {
                title: 'State Persistence',
                topics: [
                    "Volumes",
                    "PersistentVolumes & PersistentVolumeClaims"
                ]
            },
            {
                title: 'Hands-on Practice Sessions',
                topics: [
                    "CKAD Practice Exam - Part 1",
                    "CKAD Practice Exam - Part 2",
                    "CKAD Practice Exam - Part 3"
                ]
            },
        ]
    ]
}

export const KUBE_ADMIN = {
    weeks: 2,
    modules: [
        [
            {
                title: 'Understanding Kubernetes Architecture',
                topics: [
                    "Kubernetes Cluster Architecture",
                    "Kubernetes API Primitives",
                    "Kubernetes Services and Network Primitives",
                    "Exploring the Kubernetes Cluster via the Command Line"
                ],
            },
            {
                title: 'Building the Kubernetes Cluster',
                topics: [
                    "Release Binaries, Provisioning, and Types of Clusters",
                    "Installing Kubernetes Master and Nodes",
                    "Building a Highly Available Kubernetes Cluster",
                    "Configuring Secure Cluster Communications",
                    "Running End-to-End Tests on Your Cluster",
                    "Installing and Testing the Components of a Kubernetes Cluster"
                ],
            },
            {
                title: 'Managing the Kubernetes Cluster',
                topics: [
                    "Upgrading the Kubernetes Cluster",
                    "Operating System Upgrades within a Kubernetes Cluster",
                    "Backing Up and Restoring a Kubernetes Cluster",
                    "Upgrading the Kubernetes Cluster Using kubeadm"
                ],
            },
            {
                title: 'Cluster Networking',
                topics: [
                    "Pod and Node Networking",
                    "Container Network Interface (CNI)",
                    "Service Networking",
                    "Ingress Rules and Load Balancers",
                    "Cluster DNS",
                    "Creating a Service and Discovering DNS Names in Kubernetes"
                ],
            },
            {
                title: 'Pod Scheduling within the Kubernetes Cluster',
                topics: [
                    "Configuring the Kubernetes Scheduler",
                    "Running Multiple Schedulers for Multiple Pods",
                    "Scheduling Pods with Resource Limits and Label Selectors",
                    "DaemonSets and Manually Scheduled Pods",
                    "Displaying Scheduler Events",
                    "Scheduling Pods with Taints and Tolerations in Kubernetes"
                ],
            },
            {
                title: 'Deploying Applications in the Kubernetes Cluster',
                topics: [
                    "Deploying an Application, Rolling Updates, and Rollbacks",
                    "Configuring an Application for High Availability and Scale",
                    "Creating a Self-Healing Application",
                    "Performing a Rolling Update of an Application in Kubernetes"
                ],
            },
            {
                title: 'Data Management in Kubernetes',
                topics: [
                    "Persistent Volumes",
                    "Volume Access Modes",
                    "Persistent Volume Claims",
                    "Storage Objects",
                    "Applications with Persistent Storage",
                    "Creating Persistent Storage for Pods in Kubernetes"
                ],
            },
            {
                title: 'Security in Kubernetes',
                topics: [
                    "Kubernetes Security Primitives",
                    "Cluster Authentication and Authorization",
                    "Configuring Network Policies",
                    "Creating TLS Certificates",
                    "Secure Images",
                    "Defining Security Contexts",
                    "Securing Persistent Key-Value Store",
                    "Creating a ClusterRole to Access a PV in Kubernetes"
                ]
            },
            {
                title: 'Monitoring & Observability',
                topics: [
                    "Liveness and Readiness Probes",
                    "Monitoring the Cluster Components",
                    "Monitoring the Applications Running within a Cluster",
                    "Managing Cluster Component Logs",
                    "Managing Application Logs",
                    "Monitor and Output Logs to a File in Kubernetes",
                    "Debugging"
                ],
            }, {
                title: 'Identifying Failure within the Kubernetes Cluster',
                topics: [
                    "Troubleshooting Application Failure",
                    "Troubleshooting Control Plane Failure",
                    "Troubleshooting Worker Node Failure",
                    "Troubleshooting Networking",
                    "Repairing Failed Pods in Kubernetes"
                ],
            }, {
                title: 'Hands-on Practice Sessions',
                topics: [
                    "CKA Practice Exam - Part 1",
                    "CKA Practice Exam - Part 2",
                    "CKA Practice Exam - Part 3"
                ]
            },
        ]
    ]
}

